"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MessageState_1 = require("./MessageState");
var styles = require("./Message.css");
var icons = require("./../../../styles/att-icons.css");
var MessageStylesMaps_1 = require("./MessageStylesMaps");
var SECOND = 1000;
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message(props) {
        var _this = _super.call(this, props) || this;
        _this.messageParentClass = '';
        _this.messageIconClass = '';
        _this.messageChildClass = '';
        _this.messageIcon = styles.messageIcon;
        _this.state = new MessageState_1.default();
        _this.closeMessage = _this.closeMessage.bind(_this);
        _this.renderButton = _this.renderButton.bind(_this);
        _this.setDefaultClasses();
        return _this;
    }
    Message.prototype.setDefaultClasses = function () {
        if (this.props.options && this.props.options.className) {
            this.messageParentClass = this.props.options.className.messageParentClass;
            this.messageIconClass = this.props.options.className.messageIconClass;
            this.messageChildClass = this.props.options.className.messageChildClass;
        }
        if (this.props.options && this.props.options.messageIcon) {
            this.messageIcon = this.props.options.messageIcon;
        }
    };
    Message.prototype.componentDidMount = function () {
        if (this.props.data.timeToDisplay) {
            this.displayTimer = window.setTimeout(this.closeMessage, this.props.data.timeToDisplay * SECOND);
        }
    };
    Message.prototype.componentDidUpdate = function (prevProps) {
        if (typeof document === 'undefined') {
            return;
        }
        if (prevProps.options.show !== this.props.options.show) {
            this.setState({ show: this.props.options.show });
        }
    };
    Message.prototype.closeMessage = function () {
        var _this = this;
        this.setState({ show: false }, function () {
            if (_this.props.events && _this.props.events.onClose) {
                _this.props.events.onClose();
            }
            if (_this.props.events && _this.props.events.removeFromList) {
                _this.props.events.removeFromList(_this.props.data.id);
            }
            clearTimeout(_this.displayTimer);
        });
    };
    Message.prototype.getMessage = function () {
        var decorated = this.props.options.decorated === false ? ' ' : styles.decorated;
        var typeStyle = MessageStylesMaps_1.stylesMap.get(this.props.data.type);
        var containerClasses = [typeStyle, styles.message, this.messageParentClass, decorated].join(' ');
        var accessibilityText = (this.props.options.accessibility ? this.props.options.accessibility : 'Icon');
        return (React.createElement("div", { "data-test-id": this.props.testId, className: containerClasses, tabIndex: 0 },
            React.createElement("i", { className: [this.messageIcon, this.messageIconClass].join(' '), role: "img", "aria-label": accessibilityText, "data-test-id": this.props.testId + '_Icon' }),
            this.renderChildren()));
    };
    Message.prototype.render = function () {
        if (!this.state.show) {
            return null;
        }
        return this.getMessage();
    };
    Message.prototype.renderChildren = function () {
        if (this.props.children) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: [styles.childContainer, this.messageChildClass].join(' ') }, this.props.children),
                this.renderButton()));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: [styles.messageContent, this.messageChildClass].join(' '), tabIndex: 0 }, this.props.data.text),
            this.renderButton()));
    };
    Message.prototype.renderButton = function () {
        var closeButton = this.props.options.closeButton !== undefined ? this.props.options.closeButton : true;
        if (closeButton) {
            return (React.createElement(React.Fragment, null,
                React.createElement("button", { className: styles.messageClose, tabIndex: 0, role: "button", "aria-label": (this.props.options && this.props.options.closeBtnAccessibility) || 'Close', onClick: this.closeMessage },
                    React.createElement("i", { className: [icons.attIcon, icons.attIconXClose].join(' ') }))));
        }
        return null;
    };
    Message.defaultProps = {
        options: {
            accessibility: '',
            className: {},
            closeButton: true,
            decorated: true,
        },
    };
    return Message;
}(React.Component));
exports.default = Message;
//# sourceMappingURL=Message.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Message/Message.js
// module id = 459
// module chunks = 8